import { captureMessage } from "@sentry/core";
import { DateTime } from "luxon";

type Outcome = "multiple_ids" | "invalid_cookie" | "missing_ga_client_id" | "fallback_after_click";
const lastReported = new Map<Outcome, number>();

/** Four fixed keys, at most one event per outcome/minute/process, sampled at 5%. */
export function reportGoogleAdsDiagnostic(outcome: Outcome, fields: readonly string[] = []): void {
  try {
    const now = DateTime.utc().toMillis();
    if (now - (lastReported.get(outcome) ?? 0) < 60_000 || Math.random() >= 0.05) return;
    lastReported.set(outcome, now);
    captureMessage("Google Ads attribution diagnostic", {
      level: "info",
      tags: { feature: "google-attribution", outcome },
      extra: { fields },
    });
  } catch {
    // Diagnostics are best effort and must never interrupt capture or a lead.
  }
}
